import utils from '@/mixins/utils'

export function filtro(
  cadastros,
  idade_inicial,
  idade_final,
  sexo,
  exibirVermelhos,
  exibirVerdes,
  data_secretaria_de_saude,
  groupFilter
) {
  let cadastros_filtrados = cadastros

  //busca pela faixa etária
  if (idade_inicial != '' && idade_final != '') {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      let ida = parseInt(item.idade)
      return ida >= idade_inicial && ida <= idade_final
    })
  }

  // busca pelo nome
  /*  if (nome != '') {
    cadastros_filtrados = cadastros_filtrados.filter(item => {
      return item.no_cidadao.toUpperCase().indexOf(nome.toUpperCase()) > -1
    })
  } */

  // busca pelo sexo
  if (sexo != '' && sexo != 'todos') {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      return item.sexo == sexo
    })
  }

  if (groupFilter != null) {
    cadastros_filtrados = handleGroupFilter(
      cadastros_filtrados,
      groupFilter.value
    )
  }

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.dt_ultima_ficha !== null) {
        let diff = utils.methods.differenceOfDaysBetweenTwoDates(
          item.dt_ultima_ficha,
          data_secretaria_de_saude.split('/').reverse().join('-')
        )
        if (
          parseInt(diff) > 366 ||
          item.dt_ultima_ficha == null ||
          item.percent_fci_completa === null ||
          Number(item.percent_fci_completa) < 100
        ) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.dt_ultima_ficha !== null) {
        let diff = utils.methods.differenceOfDaysBetweenTwoDates(
          item.dt_ultima_ficha,
          data_secretaria_de_saude.split('/').reverse().join('-')
        )
        if (
          (parseInt(diff) <= 366 || item.dt_ultima_ficha !== null) &&
          item.percent_fci_completa !== null &&
          Number(item.percent_fci_completa) >= 100
        ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    })
  }

  return cadastros_filtrados
}

export function handleGroupFilter(data, group) {
  if (data.length > 0) {
    let filtrado = data.filter((item) => {
      if (group === 'ativos') {
        return item.saiu == '3' && item.outra_equipe == '0'
      } else if (group === 'outra-equipe') {
        return item.outra_equipe == '1'
      } else if (group === 'obitos') {
        return item.saiu == '1'
      } else if (group === 'mudou-se') {
        return item.saiu == '2'
      } else if (group === 'atendimento-recente') {
        return item.atend_pos_saiu == '1'
      } else {
        return item
      }
    })
    return filtrado
  }
}
